
import React from 'react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';
import { Save, ArrowLeft } from 'lucide-react';

interface BlogEditorHeaderProps {
  isSaving: boolean;
  isDirty: boolean;
  isNewPost: boolean;
  onSave: () => void;
}

export const BlogEditorHeader = ({ isSaving, isDirty, isNewPost, onSave }: BlogEditorHeaderProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between items-center mb-6 bg-white p-4 rounded-lg border shadow-sm">
      <div className="flex items-center gap-2">
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => navigate('/admin/blog')}
          className="text-gray-500 hover:text-gray-700"
        >
          <ArrowLeft size={18} />
        </Button>
        <h1 className="text-2xl font-bold tracking-tight">
          {isNewPost ? 'Create New Post' : 'Edit Post'}
        </h1>
      </div>
      
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          onClick={() => navigate('/admin/blog')}
        >
          Cancel
        </Button>
        <Button
          onClick={onSave}
          disabled={!isDirty || isSaving}
          className="bg-edgefi-purple hover:bg-edgefi-purple/90 flex items-center gap-2"
        >
          {isSaving ? 'Saving...' : (
            <>
              <Save size={16} />
              Save
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
